import { Heart } from 'lucide-react';

export default function Footer() {
  return (
    // <footer className="bg-gray-900 text-gray-300 py-8">
    //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    //     <div className="flex flex-col items-center justify-center space-y-4">
    //       <p className="text-sm text-center flex items-center gap-2">
    //         Made with <Heart size={16} className="text-red-500 fill-current" /> for spreading the Gospel
    //       </p>
    //       <p className="text-xs text-gray-400">
    //         © {new Date().getFullYear()} All rights reserved
    //       </p>
    //     </div>
    //   </div>
    // </footer>
    <footer className="bg-black text-white py-12 border-t-4 border-red-400">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="text-center">
          <div className="text-4xl font-black mb-2 uppercase">Latangela Rogers</div>
          <div className="text-red-400 font-bold mb-2 tracking-wider">Awakening a generation to divine purpose and destiny through prophetic leadership and kingdom reformation</div>
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
